<template>
  <div class="create-user">
    <div class="card card-custom card-compact">
      <div class="card-header card-header-nobdr">
        <div class="card-title single-title">
          <h3 class="card-label">Create User</h3>
          <span class="sub-title"
            >Fill up the basic information to create user</span
          >
        </div>
      </div>
      <div class="card-body pt-0">
        <ValidationObserver ref="observer" autocomplete="off">
          <ValidationProvider
            class="input-wrapper"
            v-slot="{ errors }"
            name="fullName"
            rules="required|name"
          >
            <v-text-field
              label="Full Name *"
              name="fullName"
              v-model="userData.fullName"
              required
            ></v-text-field>
            <span class="error-message">{{ errors[0] }}</span>
          </ValidationProvider>
          <ValidationProvider
            class="input-wrapper"
            v-slot="{ errors }"
            name="mobileNumber"
            rules="required|phone"
          >
            <v-text-field
              label="Mobile Number *"
              name="mobileNumber"
              v-model="userData.mobileNumber"
              required
            ></v-text-field>
            <span class="error-message">{{ errors[0] }}</span>
          </ValidationProvider>
          <ValidationProvider
            class="input-wrapper"
            v-slot="{ errors }"
            name="username"
            rules="required|email"
          >
            <v-text-field
              label="Login User Name *"
              name="username"
              v-model="userData.username"
              required
            ></v-text-field>
            <span class="error-message">{{ errors[0] }}</span>
          </ValidationProvider>

          <div class="form-popup-footer">
            <v-btn color="grey darken-1" text @click="closePopup">
              Close
            </v-btn>
            <v-btn
              color="primary"
              text
              @click="creatNewUser"
              :loading="loading"
              :disabled="loading"
            >
              Save
            </v-btn>
          </div>
        </ValidationObserver>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "CreateUser",
  props: {
    loading: {
      type: Boolean,
      default: false
    }
  },

  data() {
    return {
      userData: {
        fullName: "",
        mobileNumber: "",
        username: ""
      }
    };
  },
  methods: {
    closePopup() {

      for (const [key, value] of Object.entries(this.userData)) {
        this.userData[key] = "";
      }
      this.$nextTick(() => {
          this.$refs.observer.reset();
        });
      this.$emit("close");
    },
    resetForm() {
      for (const [key, value] of Object.entries(this.userData)) {
        this.userData[key] = "";
      }
    },
    async creatNewUser() {
      const valid = await this.$refs.observer.validate();
      if (valid) {
        this.$emit("postNewUser", this.userData);
      }
      this.$nextTick(() => {
          this.$refs.observer.reset();
        });
    }
  }
};
</script>
